module.exports = __webpack_public_path__ + "static/giraffeanimal2-eeb6ae6d8002fafb7d84f0fee6d9ac27.png";